import styled from "styled-components";

import { motion } from "framer-motion";

export const RightDrawerHeaderRow = styled.div.attrs({
  className:
    "flex items-center justify-between gap-4 border-b border-[var(--brand-border)] px-4 py-4 sm:px-5",
})``;

export const RightDrawerTextGroup = styled.div.attrs({ className: "min-w-0" })``;

export const RightDrawerEyebrowText = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.22em] text-[var(--brand-highlight)]",
})``;

export const RightDrawerSectionHeading = styled.h2.attrs({
  className: "mt-1 break-words text-lg font-semibold text-[var(--brand-ink)] sm:text-xl",
})``;

export const RightDrawerIconButton = styled.button.attrs({
  className:
    "flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.05)] text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)]",
})``;

export const RightDrawerScrollArea = styled.div.attrs({
  className: "flex-1 overflow-y-auto px-4 py-4 sm:px-5 sm:py-5",
})``;

export const RightDrawerOverlayMotionButton = styled(motion.button).attrs({
  className: "fixed inset-0 z-[120] bg-[rgba(4,6,9,0.72)] backdrop-blur-[2px]",
})``;

export const RightDrawerMotionPanel = styled(motion.div).attrs({
  className:
    "fixed inset-y-0 right-0 z-[121] flex w-full max-w-[560px] flex-col overflow-hidden border-l border-[var(--brand-border)] bg-[rgba(17,22,29,0.97)] shadow-[0_24px_48px_rgba(0,0,0,0.38)] backdrop-blur-xl",
})``;
